import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CodeFieldData } from "../../ui-dto/text/code-field-data";
var HTML_TEMPLATE = "\n <div data-role=\"od-code-field\">\n   <div data-role=\"od-group\">\n      <div class=\"od-group-label od-group-label-required\">Code</div>\n      <div class=\"od-group-inner\">\n        <div [class]=\"od-code-field-row\">\n            <input  *ngFor=\"let codeFieldData of _values\" \n              id=\"od-code-field-{{codeFieldData.index}}\"\n              type=\"number\"\n              min=\"0\"\n              max=\"9\"\n              [placeholder]=\"(codeFieldData.index + 1).toString()\"\n              [value]=\"codeFieldData.value\"\n              (input)=\"_handleInput($event, codeFieldData)\"\n              (focus)=\"_handleFocus(codeFieldData.index)\"\n              (keyup)=\"_handleChange($event, codeFieldData)\"\n              (keydown)=\"_handleKeyDown($event, codeFieldData)\"\n              (paste)=\"_handlePaste($event, codeFieldData)\"\n            />\n        </div>\n        <div class=\"od-code-field-row\">\n           <span *ngFor=\"let _codeFieldData of _values\" \n           [ngClass]=\"{'od-code-field-selected':_selected === _codeFieldData.index}\" ></span>\n         </div>\n      </div>\n  </div>\n</div>";
var CSS_STYLE = "\n[data-role=\"od-code-field\"] {\n  position: relative;\n}\n\n[data-role=\"od-code-field\"] [data-role=\"od-group\"] {\n  padding: 14px 29px 6px !important;\n}\n\n[data-role=\"od-code-field\"] input {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: none;\n  text-align: center;\n  margin: 0 1px;\n  font-size: 24px;\n}\n\n[data-role=\"od-code-field\"] input::placeholder {\n  color: #9a9fa7;\n}\n\n[data-role=\"od-code-field\"] input::focus-visible {\n  outline-color: #3c9bc3;\n}\n\n[data-role=\"od-code-field\"] span {\n  display: inline-block;\n  content: \" \";\n  width: 42px;\n  border-top: 2px solid #b7c1cd;\n  padding: 0 1px;\n}\n\n[data-role=\"od-code-field\"] .od-code-field-row {\n  display: flex;\n  vertical-align: middle;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: 5px;    \n  margin-top: 5px;\n}\n\n[data-role=\"od-code-field\"] span.od-code-field-selected {\n  border-top: 4px solid #3c9bc3;\n}\n\n[data-role=\"od-code-field\"] span.od-code-field-error {\n  border-top: 2px solid #FF0000;\n}\n\n[data-role=\"od-code-field\"] span.od-code-field-error.od-code-field-selected {\n  border-top: 4px solid #FF0000;\n}\n\n[data-role=\"od-code-field\"] .od-code-field-row:first-child {\n  border-radius: 5px;\n}\n\n[data-role=\"od-code-field\"] .od-group-container-input {\n  display: none;\n}\n\n[data-role=\"od-code-field\"] input::-webkit-outer-spin-button,\n[data-role=\"od-code-field\"] input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n[data-role=\"od-code-field\"] input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n[data-role=\"od-group\"] {\n  position: relative;\n  border: 1px solid #b7c1cd;\n  border-radius: 4px;\n  padding: 11px 4px 10px;\n}\n\n[data-role=\"od-group\"]:hover {\n  border: 1px solid #63c1e9;\n}\n\n[data-role=\"od-group\"].od-group-compact {\n  padding: 11px 4px 2px;\n}\n\n[data-role=\"od-group\"].od-group-no-border {\n  border: none;\n}\n\n.od-group-label {\n  background-color: #ffffff;\n  color: #5c5c5c;\n  font-size: 12px;\n  position: absolute;\n  top: -9px;\n  left: 12px;\n  padding: 0 5px;\n  z-index: 99;\n}\n\n.od-group-label-required:after {\n  content: \"*\";\n}\n\n.od-group-inner {\n  width: 100%;\n}\n\n.od-group-container-input {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  width: 100%;\n  height: 0;\n}\n\ninput.od-group-input {\n  opacity: 0;\n  height: 0;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.od-group-inner [data-role=\"od-check-box\"] {\n  height: 37px;\n  border: none;\n}\n\n.od-group-inner .od-check-box-wrapper {\n  margin-top: 0;\n}\n\n[data-role=\"od-group\"] [data-role=\"od-assignee-editor\"],\n[data-role=\"od-group\"] [data-role=\"od-follower-editor\"] {\n  margin-bottom: -2px;\n  min-height: 35px;\n}\n\n.od-group-inner [data-role=\"od-percent-complete\"] > .MuiGrid-item {\n  padding: 8px 8px 0;\n}\n\n.od-group-inner [data-role=\"od-percent-complete\"] > div:first-child > * {\n  padding: 12px 0;\n}\n\n.od-group-inner .od-combo-box-multi-button .MuiButton-text {\n  padding: 3px 8px;\n}\n\n.od-group-inner [data-role=\"od-followers-editor\"],\n.od-group-inner [data-role=\"od-assignees-editor\"] {\n  margin: -4px 0 -6px;\n}\n\n.od-group-inner [data-role=\"od-priority\"] {\n  max-height: 29px;\n}\n\n";
var CodeField = /** @class */ (function () {
    function CodeField() {
        this.onSubmit = new EventEmitter();
        this._length = 6;
        this._values = this._initValues(this._length);
        window.setTimeout(function () {
            var input = document.getElementById("od-code-field-0");
            if (input != null)
                input.focus();
        }, 500);
    }
    Object.defineProperty(CodeField.prototype, "length", {
        get: function () {
            return this._length;
        },
        set: function (value) {
            this._length = value;
            this._initValues(this._length);
        },
        enumerable: true,
        configurable: true
    });
    CodeField.prototype._handleFocus = function (index) {
        this._selected = index;
    };
    CodeField.prototype._handleChange = function (event, codeFieldData) {
        if (event.code !== "Tab") {
        }
    };
    CodeField.prototype._handleKeyDown = function (event, codeFieldData) {
        if (event.keyCode === 8) {
            var input = event.target;
            var oldvalue = input.value;
            input.value = "";
            codeFieldData.value = "";
            if (oldvalue === "") {
                var inputNext = document.getElementById("od-code-field-" +
                    (codeFieldData.index - 1));
                if (inputNext != null)
                    inputNext.focus();
            }
        }
    };
    CodeField.prototype._handleInput = function (event, codeFieldData) {
        if (event["data"] != null) {
            var input = event.target;
            this._validateMax(input);
            var oldvalue = codeFieldData.value;
            if (input.value.length > 1) {
                input.value = input.value.slice(0, 1);
            }
            if (oldvalue !== input.value) {
                var eventValue = parseInt(input.value || "", 10);
                var value = Number.isNaN(eventValue) ? "" : eventValue.toString();
                if (value && codeFieldData.index < this._values.length - 1) {
                    var input_1 = document.getElementById("od-code-field-" + (codeFieldData.index + 1));
                    if (input_1 != null)
                        input_1.focus();
                }
                codeFieldData.value = value;
            }
            var oldValues = CodeFieldData.getValues(this._values);
            this._submit(oldValues);
        }
    };
    CodeField.prototype._handlePaste = function (event, codeFieldData) {
        event.stopPropagation();
        event.preventDefault();
        var oldValues = CodeFieldData.getValues(this._values);
        var value = event.clipboardData.getData("Text").trim();
        var results = this._values;
        var j = 0;
        for (var i = codeFieldData.index; results.length > i; i++) {
            if (value.length >= j + 1) {
                results[i].value = value.substring(j, j + 1);
                var current = document.getElementById("od-code-field-" + results[i].index);
                if (current != null) {
                    current.value = results[i].value;
                }
            }
            j++;
        }
        this._submit(oldValues);
    };
    CodeField.prototype._initValues = function (length) {
        var result = [];
        var index = 0;
        Array(length).fill(1).forEach(function () {
            var codeFieldData = new CodeFieldData();
            codeFieldData.index = index++;
            result.push(codeFieldData);
        });
        return result;
    };
    CodeField.prototype._validateMax = function (input) {
        if (input.max)
            input.value = Math.min(parseInt(input.max), parseInt(input.value) ||
                (input.min == null ? 0 : parseInt(input.min))).toString();
    };
    CodeField.prototype._submit = function (oldValues) {
        var values = CodeFieldData.getValues(this._values);
        var newValue = parseInt(values.join(""), 10);
        var valid = values.every(Boolean) && this._length === values.length;
        if (valid) {
            this.onSubmit.emit(newValue);
        }
    };
    CodeField.decorators = [
        { type: Component, args: [{
                    selector: "od-code-field",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    CodeField.ctorParameters = function () { return []; };
    CodeField.propDecorators = {
        "onSubmit": [{ type: Output },],
        "length": [{ type: Input },],
    };
    return CodeField;
}());
export { CodeField };
//# sourceMappingURL=code-field.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/text/code-field.js
// module id = 979
// module chunks = 14